import React from "react";
import PropTypes from "prop-types";
import { Fragment } from "../../../shared_components/little_router";

import ActiveLink from "../../../shared_components/active_link";
import LoadingSpinner from "../../../shared_components/loading_spinner";
import CentralBlankTabMessage from "../../../shared_components/central_blank_tab_message";

import YearSelect from "../../containers/year_select";
import CityMultiSelect from "../../containers/city_multi_select";
import { makeSlug, makeChildSlug } from "../../routes";
import ResetButton from "../../containers/reset_button";
import CitiesBreakdownChart from "../../containers/visualizations/cities_breakdown_chart";
import CitiesComparisonChart from "../../containers/visualizations/cities_comparison_chart";
import CitiesHistogramChart from "../../containers/visualizations/cities_histogram_chart";
import CitiesBreakdownTable from "../../containers/visualizations/cities_breakdown_table";
import CitiesComparisonTable from "../../containers/visualizations/cities_comparison_table";
import CitiesHistogramTable from "../../containers/visualizations/cities_histogram_table";


import CitiesVerticalChart from "../../containers/visualizations/cities_vertical_chart";

class CitiesSection extends React.Component {
  render () {
    let tableAndChart = <CentralBlankTabMessage message="Please select at least one city" />;
    if (this.props.anyCitiesSelected) {
      tableAndChart = (<div>
         <div className="chart">
          <Fragment forRoute={makeChildSlug("cities", "comparison")}>
            <CitiesComparisonChart />
          </Fragment>
          <Fragment forRoute={makeChildSlug("cities", "breakdown")}>
            <CitiesBreakdownChart />
          </Fragment>
          <Fragment forRoute={makeChildSlug("cities", "histogram")}>
            <CitiesHistogramChart />
          </Fragment>
        </div>

        <div className="table">
          <Fragment forRoute={makeChildSlug("cities", "comparison")}>
            <CitiesComparisonTable />
          </Fragment>
          <Fragment forRoute={makeChildSlug("cities", "breakdown")}>
            <CitiesBreakdownTable />
          </Fragment>
          <Fragment forRoute={makeChildSlug("cities", "histogram")}>
            <CitiesHistogramTable />
          </Fragment>
        </div>
      </div>);
    }

    return (
      <div className="main">
        <div className="row">
          <div className="filter-area col-md-12">
            <YearSelect />
            <div className="form-group col-md-8">
              <h4>Pick cities to compare</h4>
              <CityMultiSelect />
            </div>

            <ResetButton />
          </div>
        </div>

        <div className="row">
          <div className="tabs col-md-2">
            <div className="info-panel"></div>
            <nav className="tab-nav">
              <h4>Change main chart</h4>
              <ActiveLink href={makeSlug("cities", "comparison")}>
                Tariffs over time by city
              </ActiveLink>
              <ActiveLink href={makeSlug("cities", "breakdown")}>
                Breakdown of charges by city
              </ActiveLink>
              <ActiveLink href={makeSlug("cities", "histogram")}>
                Tariff distribution by city & region
              </ActiveLink>
            </nav>
          </div>
          <div className="chart-and-table col-md-7">
            {tableAndChart}

            <LoadingSpinner show={this.props.isLoading}/>
          </div>

          <div className="vertical-chart col-md-3">
            <CitiesVerticalChart />
          </div>

        </div>
      </div>
    );
  }
}

CitiesSection.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  anyCitiesSelected: PropTypes.bool.isRequired
};

export default CitiesSection;
